import type { RouteRecordRaw } from 'vue-router'
import Layout from '@/layouts/BasicLayout/index.vue'

const routes: RouteRecordRaw = {
  path: '/create-supply',
  name: 'CreateSupply',
  redirect: '/create-supply/create',
  component: Layout,
  meta: {
    title: '品种管理',
    icon: 'variety|svg'
  },
  children: [
    {
      path: 'create',
      name: 'CreateSupplyList',
      component: () => import('@/views/CreateSupplyList/index.vue'),
      meta: {
        title: '品种管理',
        showGuideIcon: true
      }
    }
  ]
}
export default routes
